// Shared screening-response stats for the response views (lab + project Contacted).
// One place computes the funnel counts; two render helpers present them — StatTile
// (the lab's card) and StatChip (compact inline header chip).
import React from "react";

export const pctOf = (n, d) => (d ? Math.round((n / d) * 100) : 0);

// A row counts as "submitted" when its response-timestamp field is set. The lab
// keys off `submitted_at`; the Contacted endpoint names the same thing `responded_at`.
export const computeResponseStats = (rows, { submittedField = "submitted_at" } = {}) => {
    const list = rows || [];
    const submitted = list.filter(r => r[submittedField]);
    return {
        total: list.length,
        submitted: submitted.length,
        qualified: submitted.filter(r => r.is_qualified === true).length,
        notQualified: submitted.filter(r => r.is_qualified === false).length,
        awaiting: list.length - submitted.length,
    };
};

// Card tile — used by the standalone lab analysis page.
export const StatTile = ({ label, value, sub }) => (
    <div className="bg-white dark:bg-white/5 border border-gray-100 dark:border-gray-700/50 rounded-xl px-4 py-3.5">
        <p className="text-xs text-gray-500 dark:text-gray-400">{label}</p>
        <p className="text-2xl font-semibold text-gray-900 dark:text-white mt-1.5 leading-none">{value}</p>
        <p className="text-[11px] text-gray-400 dark:text-gray-500 mt-1.5 h-4">{sub || ""}</p>
    </div>
);

// Compact inline chip — sits on a header row without a card band. `tone` colours the
// figure so Qualified reads green / Not-qualified amber, matching the response badges.
const TONE = { good: "text-green-600", warn: "text-amber-600" };
export const StatChip = ({ label, value, sub, tone }) => (
    <span className="inline-flex items-baseline gap-1 whitespace-nowrap">
        <span className={`text-sm font-semibold ${TONE[tone] || "text-gray-900"}`}>{value}</span>
        <span className="text-xs text-gray-500 dark:text-gray-400">{label}</span>
        {sub ? <span className="text-[11px] text-gray-400 dark:text-gray-500">· {sub}</span> : null}
    </span>
);
